import styled from "styled-components";
import { Tooltip } from "react-bootstrap";
import { APP_COLORS } from "../witadmin/Common/constants";

export const FormContainer = styled("div")`
  .help-block {
    display: block;
    margin-top: 5px;
    margin-bottom: 10px;
    color: #909293;
  }
`;

export const StyledTooltip = styled(Tooltip)`
    .tooltip-inner {
        background-color: ${APP_COLORS["secondary"]};
    }
    .arrow::before {
        border-right-color: ${APP_COLORS["secondary"]};
    }
`;